var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"about main-container"},[_c('h1',{staticClass:"w-100 text-center font-weight-light mt-4",staticStyle:{"font-size":"20px","line-height":"22px"}},[_vm._v(" Page you were looking for could not be found. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }